import { Example } from "./Example";

import styles from "./Example.module.css";

export type ExampleModel = {
    text: string;
    value: string;
};

const EXAMPLES: ExampleModel[] = [
    {text:"¿Qué es una experiencia de aprendizaje?",value:"¿Qué es una experiencia de aprendizaje?"},
    {text:"¿Qué es el alineamiento constructivo?",value:"¿Qué es el alineamiento constructivo?"},
    {text:"¿Cómo se redacta un indicador de logro?",value:"¿Cómo se redacta un indicador de logro?"}
];

interface Props {
    onExampleClicked: (value: string) => void;
}

export const ExampleList = ({ onExampleClicked }: Props) => {
    return (
        <ul className={styles.examplesNavList}>
            {EXAMPLES.map((x, i) => (
                <li key={i}>
                    <Example text={x.text} value={x.value} onClick={onExampleClicked} />
                </li>
            ))}
        </ul>
    );
};
